import { Component } from '@angular/core';

@Component({
  selector: 'app-info-service',
  standalone: true,
  imports: [],
  templateUrl: './info-service.component.html',
  styleUrl: './info-service.component.scss'
})
export class InfoServiceComponent {

}
